class inViewport {
  constructor(settings) {
    this.options = Object.assign({
      sectionClass: '.shopify-section',
      inViewportClass: 'in-viewport-section',
      threshold: 0.3,
      rootMargin: '200px',
      root: null,
    }, settings);

    const sections = document.querySelectorAll(this.options.sectionClass);


    if ('IntersectionObserver' in window) {
      // IntersectionObserver Supported
      const config = {
        root: this.options.rootMargin.null,
        rootMargin: this.options.rootMargin,
        threshold: this.options.threshold
      };

      const observer = new IntersectionObserver(onChange, config);
      sections.forEach(section => observer.observe(section));

      function onChange(changes, observer) {
        changes.forEach(change => {
          if (change.intersectionRatio > 0) {
            // Stop watching and load the image
            loadImage(change.target);
            observer.unobserve(change.target);
          }
        });
      }

    } else {
      // IntersectionObserver NOT Supported
      sections.forEach(section => loadImage(section));
    }


    function loadImage(section) {
      section.classList.add('in-viewport-section');

      const imageHolders = section.querySelectorAll('.js-gif-image-holder');
      imageHolders.forEach((holder) => {
        let imgSrc = holder.getAttribute('data-gifimage');
        let duration = holder.getAttribute('data-duration');
        let imgGif = holder.querySelector('.js-gif-image');
        let imgNoNGif = holder.querySelector('.js-no-gif-image');

        imgGif.setAttribute('src', imgSrc);
        imgGif.classList.remove('js-no-gif-image--hidden');
        imgNoNGif.classList.add('js-no-gif-image--hidden');

        setTimeout(() => {
          imgGif.classList.add('js-no-gif-image--hidden');
          imgNoNGif.classList.remove('js-no-gif-image--hidden');
        }, duration);
      });

    }
  }
}
